<template>
    <div class="download-box">
        <template v-if="progressIdConfig[curItem[flag]]">
            <el-progress :text-inside="true" :stroke-width="22" :percentage="progressIdConfig[curItem[flag]]" />
            <el-button type="danger" size="small" plain @click="cancelDownload(curItem)" class="cancel-btn">
                <i class="el-icon-close"></i> <span>取消</span>
            </el-button>
        </template>
        <el-button v-else type="success" size="small" plain :disabled="Boolean(progressIdConfig[curItem[flag]])"
            @click="download(curItem)" class="download-btn">
            <i class="el-icon-download"></i><span>下载</span>
        </el-button>

    </div>
</template>

<script>
import { downloadUrlWithProgress, cancelDownload } from '@/util/utils'
export default {
    name: 'DownloadProgress',
    components: {},
    props: {
        curItem: {
            type: Object,
            default: () => ({}),
        },
        flag: {
            type: String,
            default: 'id',
        },
        filePath: {
            type: String,
            default: 'filePath',
        },
        fileName: {
            type: String,
            default: 'fileName',
        },
    },
    data() {
        return {
            progressIdConfig: {},
        };
    },
    computed: {},
    watch: {},
    created() {

    },
    mounted() { },
    methods: {
        onDownloadProgress(progressEvent, id) {
            const percent = (progressEvent.loaded / progressEvent.total) * 100;
            const progress = Number(percent.toFixed(2))

            this.progressIdConfig[id] = progress
            this.progressIdConfig = { ...this.progressIdConfig }

            if (progress == 100 || !isFinite(progress)) {
                // 下载完成或出错时清理进度
                setTimeout(() => {
                    delete this.progressIdConfig[id];
                    this.progressIdConfig = { ...this.progressIdConfig }
                }, 500)
            }
        },

        getUrl(itemFilePath) {
            let url = ''
            this.$emit('get-download-url', itemFilePath, (item) => {
                url = item
            })
            return url;
        },
        async download(item) {
            if (this.progressIdConfig[item[this.flag]]) return
            this.$confirm(`确定下载吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                this.progressIdConfig[item[this.flag]] = 0
                this.progressIdConfig = { ...this.progressIdConfig }
                try {
                    await downloadUrlWithProgress(
                        this.getUrl(item[this.filePath]),
                        item[this.fileName],
                        item[this.flag],
                        this.onDownloadProgress
                    )
                } catch (error) {
                    // 下载失败或取消时清理进度
                    if (error.message !== '下载已被取消') {
                        this.$message.error('下载失败: ' + error.message);
                    }
                    delete this.progressIdConfig[item[this.flag]];
                    this.progressIdConfig = { ...this.progressIdConfig }
                }
            })
        },

        cancelDownload(item) {
            this.$confirm(`确定取消下载吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const success = cancelDownload(item[this.flag]);
                if (success) {
                    // 立即清理进度显示
                    delete this.progressIdConfig[item[this.flag]];
                    this.progressIdConfig = { ...this.progressIdConfig }
                    this.$message.success('下载已取消');
                } else {
                    this.$message.warning('下载任务不存在或已完成');
                }
            })
        },
    }
};
</script>

<style scoped lang='scss'>
.download-box {
    width: 200px;
    display: flex;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;


    .el-progress {
        flex: 0.5;
    }
}
</style>